import React from 'react';

const LanguageArrow = ({ active }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" className={active}>
      <path d="M12 15L7 10H17L12 15Z" />
    </svg>
  );
};

export default LanguageArrow;
